import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';

const Container = styled.div`
  height: 100vh;
  background-color: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  font-family: 'Prompt', sans-serif;
`;

const Card = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  padding: 2rem;
  width: 100%;
  max-width: 24rem;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
  color: #06b6d4;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-size: 1rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
`;

const Spinner = styled.div`
  border: 4px solid #f3f4f6;
  border-top: 4px solid #06b6d4;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const ErrorIcon = styled.div`
  width: 4rem;
  height: 4rem;
  background-color: #ef4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  font-size: 2rem;
  color: white;
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  background-color: #06b6d4;
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0891b2;
  }
`;

const TokenLogin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('กำลังตรวจสอบข้อมูล...');

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage('ไม่พบ Token กรุณาเข้าสู่ระบบใหม่อีกครั้ง');
      return;
    }

    const performLogin = async () => {
      const result = await loginWithToken(token);

      if (result.success) {
        setStatus('success');
        setMessage(`ยินดีต้อนรับ ${result.user.name}`);

        // Redirect to healthbook after 1 second
        setTimeout(() => {
          navigate('/healthbook');
        }, 1000);
      } else {
        setStatus('error');
        setMessage(result.message);
      }
    };

    performLogin();
  }, [searchParams, loginWithToken, navigate]);

  const handleGoToLogin = () => {
    navigate('/login');
  };

  return (
    <Container>
      <Card>
        {status === 'loading' && (
          <>
            <Spinner />
            <Title>กำลังเข้าสู่ระบบ</Title>
            <Message>{message}</Message>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✓</div>
            <Title>เข้าสู่ระบบสำเร็จ</Title>
            <Message>{message}</Message>
            <Message style={{ fontSize: '0.875rem', color: '#9ca3af' }}>
              กำลังนำคุณไปยังระบบ...
            </Message>
          </>
        )}

        {status === 'error' && (
          <>
            <ErrorIcon>✕</ErrorIcon>
            <Title style={{ color: '#ef4444' }}>เกิดข้อผิดพลาด</Title>
            <Message style={{ color: '#dc2626' }}>{message}</Message>
            <Button onClick={handleGoToLogin}>กลับไปหน้าเข้าสู่ระบบ</Button>
          </>
        )}
      </Card>
    </Container>
  );
};

export default TokenLogin;
